const namespace = {
  title: "Local Demographics",
  note: "Displaying demographics statistics for area {{value}} {{unit}} around selected location.",
  noData: "No demographic information is available for this specific location.",
  data: {
    income: {
      title: "Income",
      graphs: {
        averageIncome: {
          title: "Average Income",
          types: {
            avg_household_income: "Family",
            avg_individual_income: "Individual",
          },
        },
        employment: {
          title: "Employment",
        },
        incomeBrackets: {
          title: "Income Brackets",
        },
      },
    },
    population: {
      title: "Population",
      graphs: {
        totalPopulation: {
          title: "Total Population",
        },
        populationByAgeGroup: {
          title: "Population By Age Group",
        },
      },
    },
    housing: {
      title: "Housing",
      graphs: {
        homeOwnershipType: {
          title: "Owners vs Renters",
        },
        typeOfHousing: {
          title: "Type of Housing",
        },
      },
    },
    household: {
      title: "Household",
      graphs: {
        householdComposition: {
          title: "Household Composition",
        },
      },
    },
    education: {
      title: "Education",
      graphs: {
        educationLevel: {
          title: "Highest Level Of Education Achieved",
        },
      },
    },
    commute: {
      title: "Commute",
      graphs: {
        commuteMode: {
          title: "Commute Mode",
        },
      },
    },
    languages: {
      title: "Languages",
      graphs: {
        spokenLanguages: {
          title: "Spoken Official Languages",
        },
        motherTongue: {
          title: "Mother Tongue",
        },
      },
    },
  },
} as const;

export default namespace;
